import { Header, Footer } from '@/components/layout'
import { SEO } from '@/components/seo'

export default function DocsPage() {
  return (
    <div className="min-h-screen bg-surface-950">
      <SEO
        title="Documentation"
        description="Get started with JumpstoneAuth in minutes. Comprehensive guides, API reference, and SDK documentation."
        canonical="/docs"
      />
      <Header />
      <main className="pt-24 pb-16">
        <div className="mx-auto max-w-7xl section-padding">
          <h1 className="text-4xl font-bold text-white mb-4">Documentation</h1>
          <p className="text-lg text-surface-400">Get started with JumpstoneAuth</p>
        </div>
      </main>
      <Footer />
    </div>
  )
}

